              import React from 'react'
import reason1 from '../assets/reason1.jpg';
import reason2 from '../assets/reason2.jpg';
import { useTranslation } from 'react-i18next';

function ReasonForUtilisation() {
    const { t } = useTranslation();

    return (

        <div className="container-fluid p-0 ">
            {/* Header */}
            <div className="container-fluid text-white py-4  " style={{ backgroundColor: "rgba(9, 26, 58, 1)" }}>
                <div className="container text-end px-5 d-flex flex-column justify-content-end">
                    <h5 className="fw-semibold mb-1">{t('reasonTitle')}</h5>
                    <hr className="border-white opacity-100 ms-auto" style={{ width: "220px" }} />
                </div>
            </div>


            {/* Content */}
            <div className="container py-5">
                <div className="row align-items-start">
                    {/* Illustration */}
                    <div className="col-lg-4 mb-4 mb-lg-0 text-center">
                        <img
                            src={reason1}
                            alt="Reason Illustration"
                            className="img-fluid mb-4"
                            data-aos="fade-down"
                        />
                        <img
                            src={reason2}
                            alt="Warehouse Icon"
                            className="img-fluid w-50"
                            data-aos="fade-up"
                        />
                    </div>


                    {/* Text Content */}
                    <div className="col-lg-8">
                        <ul className="fs-6" >
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="100">{t('reasonPoint1')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="200">{t('reasonPoint2')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="300">{t('reasonPoint3')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="400">{t('reasonPoint4')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="500">{t('reasonPoint5')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="600">{t('reasonPoint6')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="700">{t('reasonPoint7')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="800">{t('reasonPoint8')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="900">{t('reasonPoint9')}</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="1000">{t('reasonPoint10')}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ReasonForUtilisation